import { render, staticRenderFns } from "./Arbitrator.vue?vue&type=template&id=0f8f5326&scoped=true&"
import script from "./Arbitrator.vue?vue&type=script&lang=js&"
export * from "./Arbitrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f5326",
  null
  
)

export default component.exports